<template>
    <div class="c-global-loader" ref="$loader">
        <div class="c-circle">
            <div class="inner">
                <div class="c-logo" ref="$logo">
                    <SvgsLogo :fill_1="'var(--dark)'" />
                </div>
            </div>
        </div>
        <div class="c-percentage">
            <span class="label">Loading</span>
            <span class="percenatge">
                <span class="counter" ref="$counter">0</span>
                <span class="symbol">%</span>
            </span>
        </div>
    </div>
</template>

<script setup>
    const LOADER_DURATION = 0.8;
    const LOADER_MAX_MS = 1200;
    const LOADER_SETTLE_MS = 100;

    const { $gsap: gsap } = useNuxtApp();
    const globalStore = useGlobalStore();
    const $loader = ref(null);
    const $logo = ref(null);
    const $counter = ref(null);
    const counter = { value: 0 };
    let finished = false;

    const complete = () => {
        if (finished) return;
        finished = true;
        globalStore.setPageTransitionBeforeComplete(true);
        globalStore.setAppLoadingComplete(true);
        globalStore.setPageTransitionComplete(true);
    };

    onMounted(() => {
        const rootElement = document.documentElement;
        const hardTimeout = window.setTimeout(complete, LOADER_MAX_MS);

        nextTick(() => {
            gsap.to(rootElement, {
                duration: LOADER_DURATION,
                ease: "circ.out",
                ["--circle-loader"]: "100%"
            });

            gsap.to($logo.value, {
                opacity: 1,
                duration: Math.min(0.5, LOADER_DURATION)
            });

            gsap.to($logo.value, {
                webkitFilter: "blur(0px)",
                filter: "blur(0px)",
                duration: LOADER_DURATION
            });

            gsap.to(counter, {
                value: 100,
                duration: LOADER_DURATION,
                ease: "sine.out",
                onUpdate: () => {
                    if ($counter.value) {
                        $counter.value.innerHTML = counter.value.toFixed(1);
                    }
                },
                onComplete: () => {
                    window.clearTimeout(hardTimeout);
                    window.setTimeout(complete, LOADER_SETTLE_MS);
                }
            });
        });
    });
</script>
